import { createSelector } from 'reselect'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { getDurationPackageOptions } from 'selectors/offerPage/offerPageSelectors'
import type { PackagesOptionsViewsByRoom } from 'selectors/offerPage/multipleRoomBookingSelectors'
import { EmptyObject } from 'lib/object/objectUtils'

export const getFlashPackageViewsByOccupancy = createSelector(
  (state: OfferPageState) => state.rooms,
  (state: OfferPageState, appState: App.State) => getDurationPackageOptions(state, appState),
  (rooms, combinedViews): PackagesOptionsViewsByRoom => rooms.length === 1
    ? { [rooms[0].id]: combinedViews }
    : EmptyObject,
)
